import { useState } from 'react'
import { Clock, LogOut, RefreshCw } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

export default function PendingApprovalScreen() {
    const { signOut, refreshProfile } = useAuth()
    const [checking, setChecking] = useState(false)

    const handleCheck = async () => {
        setChecking(true)
        await refreshProfile()
        setChecking(false)
    }

    return (
        <section className="no-company-screen">
            <div className="no-company-shell">
                <div className="no-company-hero">
                    <div className="empty-state no-company-hero-card">
                        <div className="empty-state-icon">
                            <Clock size={60} style={{ color: 'var(--accent-yellow, #eab308)' }} />
                        </div>
                        <h2 className="empty-state-title">
                            Contul tau este in curs de aprobare
                        </h2>
                        <p className="empty-state-text">
                            Un administrator trebuie sa activeze contul tau inainte de a putea accesa Kanbify.
                            Revino mai tarziu sau contacteaza administratorul companiei.
                        </p>

                        <div className="no-company-actions" style={{ marginTop: '1.5rem', display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
                            <button type="button" className="btn btn-primary" onClick={handleCheck} disabled={checking}>
                                <RefreshCw size={14} className={checking ? 'spin' : ''} />
                                {checking ? 'Se verifica...' : 'Verifica din nou'}
                            </button>
                            <button type="button" className="btn btn-secondary" onClick={signOut}>
                                <LogOut size={14} /> Deconectare
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
